import Service from "./Service";

class BusAutomaticApprovalApiService extends Service {
  constructor() {
    super("api/BusAutomaticApprovalSettings");
  }

  async getAll() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    return result;
  }

  async update(key, payload) {
    let result = await this.post(`/${key}`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async add(payload) {
    let result = await this.post(``, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async deleteByKey(key) {
    let result = await this.delete(`/${key}`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new BusAutomaticApprovalApiService();
